<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <h4>{{ title }}</h4>
        </div>
    </div>
    <div class="row mt-4">
        <div class="col-12">
            <div class="d-flex justify-content-center">
                <button mat-stroked-button (click)="validar()" class="btn-success">
                    <mat-icon>done</mat-icon>
                    Validar
                </button>
                <button mat-stroked-button (click)="rechazar()" class="ms-3">
                    <mat-icon>cancel</mat-icon>
                    Cancelar
                </button>
            </div>
        </div>
    </div>
</div>